import React from "react";
import "../CSS/Header.css";
import { ChevronLeftIcon, XMarkIcon } from "@heroicons/react/24/outline";
import { PiArrowsOutSimpleBold } from "react-icons/pi";
import { PiArrowsInSimpleBold } from "react-icons/pi";
// import logo from "../assets/logo.png";

function Header({
  setIsOpen,
  view,
  setView,
  setIsExpanded,
  isExpanded,
  logo,
  setupDetails,
  setActiveIcon,
}) {
  const isMobile = window.innerWidth < 768; // Adjust the breakpoint as needed

  return (
    <div
      className="dexkor-header"
      style={{
        background: `linear-gradient(90deg, ${setupDetails?.widgetCustomizations.secondaryColor} 0%, ${setupDetails?.widgetCustomizations.primaryColor} 100%)`,
      }}
    >
      {view !== "message" && view !== "MessageDetails" && (
        <div className="flex items-center p-3 gap-1">
          <ChevronLeftIcon
            onClick={() => {
              // Collapse widget and navigate to LandingWindow
              if (
                [
                  "AIAgentInfo",
                  "MetricsAndAttributes",
                  "CDAInfo",
                  "SupportContent",
                  "DexKor",
                ].includes(view)
              ) {
                setIsExpanded(false);
              }

              // Check if current view is DexKor, navigate to DexKor Overview
              if (view === "DexKor") {
                setView("DexKorOverview"); // Set the view to DexKor Overview
                setActiveIcon("help"); // Set active icon to Help when navigating to DexKor Overview
              } else {
                setView("LandingWindow"); // Default navigation to LandingWindow
                setActiveIcon("home"); // Set active icon to home for LandingWindow
              }
            }}
            className="w-5 h-5 text-white cursor-pointer"
          />
          {view !== "AIAgentInfo" &&
            view !== "MetricsAndAttributes" &&
            view !== "CDAInfo" &&
            view !== "SupportContent" &&
            view !== "DexKor" &&
            view !== "MessageDetails" && (
              <img
                src={logo}
                alt="Brand-icon"
                className="dexkor-brand-icon -ml-2"
              />
            )}
        </div>
      )}
      {!isMobile ? (
        <button
          className="dexkor-close-button z-50"
          onClick={() => setIsExpanded(!isExpanded)} // Trigger the popup for expanding the chat widget
        >
          {isExpanded ? (
            <PiArrowsInSimpleBold className="text-white h-4 w-4" />
          ) : (
            <PiArrowsOutSimpleBold className="text-white h-4 w-4" />
          )}
        </button>
      ) : (
        <button
          className="dexkor-close-button z-50"
          onClick={() => {
            setIsOpen(false);
            setIsExpanded(false);
          }} // Close the widget on mobile
        >
          <XMarkIcon className="text-white h-4 w-4" />
        </button>
      )}
    </div>
  );
}

export default Header;
